/**
 * Tangram Design Tokens v3.4.0
 * Code generated by @resultadosdigitais/tangram-design-tokens. DO NOT EDIT.
 * Copyright Resultados Digitais. 2022
 */

const version = '3.4.0';
const sizeSpacing01 = '4px';
const sizeSpacing02 = '8px';
const sizeSpacing03 = '12px';
const sizeSpacing04 = '16px';
const sizeSpacing05 = '24px';
const sizeSpacing06 = '32px';
const sizeSpacing07 = '40px';
const sizeSpacing08 = '48px';
const sizeSpacing09 = '56px';
const sizeSpacing10 = '64px';
const sizeSpacing11 = '96px';
const sizeSpacing12 = '160px';
const colorGray100 = '#212429';
const colorGray90 = '#3A4149';
const colorGray80 = '#636E7C';
const colorGray70 = '#7E8A98';
const colorGray60 = '#97A1AC';
const colorGray50 = '#ACB4BD';
const colorGray40 = '#BEC4CB';
const colorGray30 = '#CFD3D8';
const colorGray20 = '#E1E4E8';
const colorGray10 = '#F1F3F5';
const colorWhite = '#FFFFFF';
const colorRed100 = '#5F1625';
const colorRed90 = '#781A2D';
const colorRed80 = '#9A273E';
const colorRed70 = '#BE3450';
const colorRed60 = '#E34263';
const colorRed50 = '#ED6478';
const colorRed40 = '#F58491';
const colorRed30 = '#FBABB2';
const colorRed20 = '#FFD6DA';
const colorRed10 = '#FFF0F3';
const colorYellow100 = '#B24D09';
const colorYellow90 = '#CB6D18';
const colorYellow80 = '#DA8C30';
const colorYellow70 = '#E9A846';
const colorYellow60 = '#F7C85E';
const colorYellow50 = '#F9D37D';
const colorYellow40 = '#FADD9B';
const colorYellow30 = '#FCE7B8';
const colorYellow20 = '#FDF1D4';
const colorYellow10 = '#FFFBF0';
const colorGreen100 = '#14521F';
const colorGreen90 = '#25702E';
const colorGreen80 = '#37903D';
const colorGreen70 = '#4AB24D';
const colorGreen60 = '#5ED45E';
const colorGreen50 = '#7DDD7F';
const colorGreen40 = '#9AE69E';
const colorGreen30 = '#B6EFBC';
const colorGreen20 = '#D1F7D8';
const colorGreen10 = '#EBFFF4';
const colorPurple100 = '#380E58';
const colorPurple90 = '#581E8A';
const colorPurple80 = '#7331A6';
const colorPurple70 = '#853CBD';
const colorPurple60 = '#914DC4';
const colorPurple50 = '#A46EE5';
const colorPurple40 = '#BA92EB';
const colorPurple30 = '#CFB2F2';
const colorPurple20 = '#E3D1F8';
const colorPurple10 = '#F7F0FF';
const colorMidnightblue1 = '#2D0994';
const colorMidnightblue2 = '#431AB6';
const colorMidnightblue3 = '#431AB6';
const colorMidnightblue4 = '#7E5BE2';
const colorOrchid1 = '#7100B7';
const colorOrchid2 = '#880DD3';
const colorOrchid3 = '#A025EB';
const colorOrchid4 = '#BC51FD';
const colorDeepskyblue1 = '#0580F1';
const colorDeepskyblue2 = '#2C9AFF';
const colorDeepskyblue3 = '#5FB2FF';
const colorDeepskyblue4 = '#8DC8FF';
const colorDeeppurple1 = '#730075';
const colorDeeppurple2 = '#822884';
const colorDeeppurple3 = '#9A179C';
const colorDeeppurple4 = '#C42FC7';
const colorDeeppink1 = '#9F0160';
const colorDeeppink2 = '#BD0071';
const colorDeeppink3 = '#D30480';
const colorDeeppink4 = '#DF54A8';
const colorVioletred1 = '#DC2794';
const colorVioletred2 = '#F047AC';
const colorVioletred3 = '#FF5FBF';
const colorVioletred4 = '#FE77C8';
const colorTan1 = '#B76300';
const colorTan2 = '#C7710C';
const colorTan3 = '#DB821A';
const colorTan4 = '#E9993C';
const colorSienna1 = '#EB5D2E';
const colorSienna2 = '#EE7349';
const colorSienna3 = '#FF8B64';
const colorSienna4 = '#FFA081';
const colorGoldenorange1 = '#F4A812';
const colorGoldenorange2 = '#FFC044';
const colorGoldenorange3 = '#FFCD6B';
const colorGoldenorange4 = '#FFDD99';
const colorOlive1 = '#909300';
const colorOlive2 = '#AAAD06';
const colorOlive3 = '#C1C521';
const colorOlive4 = '#D5D839';
const colorSeagreen1 = '#0BB280';
const colorSeagreen2 = '#0BCB91';
const colorSeagreen3 = '#16DCA1';
const colorSeagreen4 = '#28EAB0';
const textFontFamily = "'Nunito Sans', 'Open Sans', Arial, sans-serif";
const textLineHeight = '1.5';
const textLineHeightMd = '1.4';
const textLineHeightSm = '1.3';
const textSizeXxl = '36px';
const textSizeXl = '28px';
const textSizeLg = '20px';
const textSizeMd = '16px';
const textSizeSm = '14px';
const textSizeXs = '12px';
const textWeightRegular = 'normal';
const textWeightBold = 'bold';
const textWeightExtrabold = '800';
const textXxlBold =
  'var(--text-weight-bold) var(--text-size-xxl)/46px var(--text-font-family)';
const textXxlExtrabold =
  'var(--text-weight-extrabold) var(--text-size-xxl)/46px var(--text-font-family)';
const textXxlRegular =
  'var(--text-weight-regular) var(--text-size-xxl)/46px var(--text-font-family)';
const textXlBold =
  'var(--text-weight-bold) var(--text-size-xl)/36px var(--text-font-family)';
const textXlExtrabold =
  'var(--text-weight-extrabold) var(--text-size-xl)/36px var(--text-font-family)';
const textXlRegular =
  'var(--text-weight-regular) var(--text-size-xl)/36px var(--text-font-family)';
const textLgBold =
  'var(--text-weight-bold) var(--text-size-lg)/30px var(--text-font-family)';
const textLgExtrabold =
  'var(--text-weight-extrabold) var(--text-size-lg)/30px var(--text-font-family)';
const textLgRegular =
  'var(--text-weight-regular) var(--text-size-lg)/30px var(--text-font-family)';
const textMdBold =
  'var(--text-weight-bold) var(--text-size-md)/24px var(--text-font-family)';
const textMdExtrabold =
  'var(--text-weight-extrabold) var(--text-size-md)/24px var(--text-font-family)';
const textMdRegular =
  'var(--text-weight-regular) var(--text-size-md)/24px var(--text-font-family)';
const textSmBold =
  'var(--text-weight-bold) var(--text-size-sm)/20px var(--text-font-family)';
const textSmExtrabold =
  'var(--text-weight-extrabold) var(--text-size-sm)/20px var(--text-font-family)';
const textSmRegular =
  'var(--text-weight-regular) var(--text-size-sm)/20px var(--text-font-family)';
const textXsBold =
  'var(--text-weight-bold) var(--text-size-xs)/16px var(--text-font-family)';
const textXsExtrabold =
  'var(--text-weight-extrabold) var(--text-size-xs)/16px var(--text-font-family)';
const textXsRegular =
  'var(--text-weight-regular) var(--text-size-xs)/16px var(--text-font-family)';
const shadowXl = '0px 18px 32px rgba(33, 36, 41, 0.3)';
const shadowLg = '0px 12px 24px rgba(33, 36, 41, 0.2)';
const shadowMd = '0px 8px 18px rgba(33, 36, 41, 0.16)';
const shadowSm = '0px 4px 12px rgba(33, 36, 41, 0.14)';
const shadowXs = '0px 2px 6px rgba(33, 36, 41, 0.1)';
const borderRadiusRounded = '2px';
const borderRadiusCircle = '50%';
const borderRadiusPill = '999px';
const motionDurationExtraFast = '100ms';
const motionDurationFast = '200ms';
const motionDurationNormal = '300ms';
const motionDurationSlow = '400ms';
const motionDurationExtraSlow = '500ms';
const motionDurationUltraSlow = '1000ms';
const motionTimingFunctionEaseIn =
  'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const motionTimingFunctionEaseOut =
  'cubic-bezier(0.215, 0.61, 0.355, 1)';
const motionTimingFunctionEaseInOut =
  'cubic-bezier(0.645, 0.045, 0.355, 1)';
const breakpointXs = '480px';
const breakpointSm = '768px';
const breakpointMd = '1024px';
const breakpointLg = '1280px';
const breakpointXl = '1440px';
const breakpointMax = '1920px';
const zindexAuto = 'auto';
const zindex0 = '1';
const zindex1 = '1000';
const zindex2 = '1010';
const zindex3 = '1020';
const zindex4 = '1030';
const zindex5 = '1040';
const zindex6 = '1050';
const zindexBack = '-1';

const themes = { lina: 'lina', crm: 'crm', marketing: 'marketing' };

var tangramDesignTokens = (theme, mode = 'light') => {
  const themeVariables = {
    lina: {
      light: {
        colorPrimary10: '#EBFDFF',
        colorPrimary20: '#CAFAFC',
        colorPrimary30: '#9FF2F5',
        colorPrimary40: '#78EDF2',
        colorPrimary50: '#3BE5EB',
        colorPrimary60: '#19C1CE',
        colorPrimary70: '#11A7B6',
        colorPrimary80: '#008096',
        colorPrimary90: '#005E72',
        colorPrimary100: '#0B485B',
        neutralBorder: '#D5D8DB',
        neutralBorderInteractive: '#9EA5AC',
        neutralBorderInteractiveHover: '#79818A',
        neutralBorderInteractiveDisabled: '#DDDFE0',
        neutralIconHighEmphasis: '#212429',
        neutralIconLowEmphasis: '#858C94',
        neutralIconDisabled: '#CFD3D8',
        neutralIconInverse: '#FFFFFF',
        neutralSurface: '#FFFFFF',
        neutralSurfaceHighEmphasis: '#E3E5E8',
        neutralSurfaceLowEmphasis: '#F1F3F5',
        neutralSurfaceHover: '#E9EBED',
        neutralSurfaceDisabled: '#EEF0F2',
        neutralSurfaceInverse: '#212429',
        neutralSurfaceInverseHover: '#33373D',
        neutralTextHighEmphasis: '#212429',
        neutralTextLowEmphasis: '#636E7C',
        neutralTextDisabled: '#868C94',
        neutralTextInverse: '#FFFFFF',
        primaryBorder: '#19C1CE',
        primaryBorderHover: '#008096',
        primaryIcon: '#11A7B6',
        primaryIconHover: '#008096',
        primarySurfaceHighEmphasis: '#19C1CE',
        primarySurfaceLowEmphasis: '#CAFAFC',
        primarySurfaceHover: '#3BE5EB',
        primaryText: '#11A7B6',
        primaryTextHover: '#008096',
        primaryTextOnColor: '#19C1CE',
        primaryTextOnColorHover: '#1CDCEB',
        dangerBorder: '#E34263',
        dangerIcon: '#E34263',
        dangerSurfaceHover: '#F82D57',
        dangerSurfaceHighEmphasis: '#E34263',
        dangerSurfaceLowEmphasis: '#FFD4D9',
        dangerText: '#DC3356',
        dangerTextOnColor: '#FF4E69',
        dangerTextOnColorHover: '#FF4053',
        warningBorder: '#F7C85E',
        warningIcon: '#F7C85E',
        warningSurfaceHover: '#FFBD28',
        warningSurfaceHighEmphasis: '#F7C85E',
        warningSurfaceLowEmphasis: '#FFEDC6',
        warningText: '#C76D07',
        warningTextOnColor: '#FFB341',
        successBorder: '#5ED45E',
        successIcon: '#5ED45E',
        successSurfaceHover: '#1ED01E',
        successSurfaceHighEmphasis: '#5ED45E',
        successSurfaceLowEmphasis: '#CEF8D0',
        successText: '#3B843B',
        successTextOnColor: '#63C963',
        highlightBorder: '#914DC4',
        highlightIcon: '#914DC4',
        highlightSurfaceHover: '#853CBD',
        highlightSurfaceHighEmphasis: '#914DC4',
        highlightSurfaceLowEmphasis: '#E3D1F8',
        highlightText: '#7331A6',
        highlightTextOnColor: '#914DC4'
      }
    },
    crm: {
      light: {
        colorPrimary10: '#E6FBFF',
        colorPrimary20: '#A6EFFF',
        colorPrimary30: '#7DE3FF',
        colorPrimary40: '#54D4FF',
        colorPrimary50: '#2BC3FF',
        colorPrimary60: '#03A9F4',
        colorPrimary70: '#0086CF',
        colorPrimary80: '#0068A8',
        colorPrimary90: '#004C82',
        colorPrimary100: '#00325C'
      }
    },
    marketing: {
      light: {
        colorPrimary10: '#E6F6FF',
        colorPrimary20: '#B8E2FF',
        colorPrimary30: '#8FCEFF',
        colorPrimary40: '#63B2F7',
        colorPrimary50: '#3891EB',
        colorPrimary60: '#1272DE',
        colorPrimary70: '#0653B8',
        colorPrimary80: '#003A91',
        colorPrimary90: '#00276B',
        colorPrimary100: '#001745'
      }
    }
  };

  if (!themeVariables.hasOwnProperty(theme)) {
    console.error('Property ' + theme + ' does not exist!');
    return;
  }

  if (!themeVariables[theme].hasOwnProperty(mode)) {
    console.error('Mode "' + mode + '" does not exist!');
    return;
  }

  return themeVariables[theme][mode];
};

export { borderRadiusCircle, borderRadiusPill, borderRadiusRounded, breakpointLg, breakpointMax, breakpointMd, breakpointSm, breakpointXl, breakpointXs, colorDeeppink1, colorDeeppink2, colorDeeppink3, colorDeeppink4, colorDeeppurple1, colorDeeppurple2, colorDeeppurple3, colorDeeppurple4, colorDeepskyblue1, colorDeepskyblue2, colorDeepskyblue3, colorDeepskyblue4, colorGoldenorange1, colorGoldenorange2, colorGoldenorange3, colorGoldenorange4, colorGray10, colorGray100, colorGray20, colorGray30, colorGray40, colorGray50, colorGray60, colorGray70, colorGray80, colorGray90, colorGreen10, colorGreen100, colorGreen20, colorGreen30, colorGreen40, colorGreen50, colorGreen60, colorGreen70, colorGreen80, colorGreen90, colorMidnightblue1, colorMidnightblue2, colorMidnightblue3, colorMidnightblue4, colorOlive1, colorOlive2, colorOlive3, colorOlive4, colorOrchid1, colorOrchid2, colorOrchid3, colorOrchid4, colorPurple10, colorPurple100, colorPurple20, colorPurple30, colorPurple40, colorPurple50, colorPurple60, colorPurple70, colorPurple80, colorPurple90, colorRed10, colorRed100, colorRed20, colorRed30, colorRed40, colorRed50, colorRed60, colorRed70, colorRed80, colorRed90, colorSeagreen1, colorSeagreen2, colorSeagreen3, colorSeagreen4, colorSienna1, colorSienna2, colorSienna3, colorSienna4, colorTan1, colorTan2, colorTan3, colorTan4, colorVioletred1, colorVioletred2, colorVioletred3, colorVioletred4, colorWhite, colorYellow10, colorYellow100, colorYellow20, colorYellow30, colorYellow40, colorYellow50, colorYellow60, colorYellow70, colorYellow80, colorYellow90, tangramDesignTokens as default, motionDurationExtraFast, motionDurationExtraSlow, motionDurationFast, motionDurationNormal, motionDurationSlow, motionDurationUltraSlow, motionTimingFunctionEaseIn, motionTimingFunctionEaseInOut, motionTimingFunctionEaseOut, shadowLg, shadowMd, shadowSm, shadowXl, shadowXs, sizeSpacing01, sizeSpacing02, sizeSpacing03, sizeSpacing04, sizeSpacing05, sizeSpacing06, sizeSpacing07, sizeSpacing08, sizeSpacing09, sizeSpacing10, sizeSpacing11, sizeSpacing12, textFontFamily, textLgBold, textLgExtrabold, textLgRegular, textLineHeight, textLineHeightMd, textLineHeightSm, textMdBold, textMdExtrabold, textMdRegular, textSizeLg, textSizeMd, textSizeSm, textSizeXl, textSizeXs, textSizeXxl, textSmBold, textSmExtrabold, textSmRegular, textWeightBold, textWeightExtrabold, textWeightRegular, textXlBold, textXlExtrabold, textXlRegular, textXsBold, textXsExtrabold, textXsRegular, textXxlBold, textXxlExtrabold, textXxlRegular, themes, version, zindex0, zindex1, zindex2, zindex3, zindex4, zindex5, zindex6, zindexAuto, zindexBack };
